import React, {useState} from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import * as waxjs from "@waxio/waxjs/dist";
import { createBrowserHistory } from "history";


import routes  from './const/routes';
import { RPC_SERVER }  from './const';
import LandingPage from './pages/landing';

import Context from './context';

const history = createBrowserHistory();


function App() {
  const [wax, setWax] = useState(() => new waxjs.WaxJS(RPC_SERVER, null, null, false));

  return (
    <Context.Provider value={{wax, setWax}}>
      <Router history={history} basename="/redeem/gpk1/">
        <Switch>
          <Route exact path={routes.landing} component={LandingPage} />
          <Redirect to={routes.landing} />
        </Switch>
      </Router>
    </Context.Provider>
  )
}

export default App;
